import { Navigate, Outlet, Link, NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LOGO_WHITE } from "../lib/api";
import { LogOut, Tv, Clapperboard, CalendarDays, Users, Mail, LayoutDashboard } from "lucide-react";

const NAV = [
    { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard, testId: "admin-nav-dashboard" },
    { to: "/admin/events", label: "Eventi", icon: CalendarDays, testId: "admin-nav-events" },
    { to: "/admin/productions", label: "Produzioni TV", icon: Tv, testId: "admin-nav-productions" },
    { to: "/admin/formats", label: "Format TV", icon: Clapperboard, testId: "admin-nav-formats" },
    { to: "/admin/talents", label: "Talent & Ospiti", icon: Users, testId: "admin-nav-talents" },
    { to: "/admin/contacts", label: "Messaggi", icon: Mail, testId: "admin-nav-contacts" },
];

export default function AdminLayout() {
    const { user, loading, logout } = useAuth();
    const location = useLocation();

    if (loading) return <div className="min-h-screen bg-black text-white/60 flex items-center justify-center">Caricamento…</div>;
    if (!user || user.role !== "admin") return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;

    return (
        <div className="min-h-screen bg-[#0a0a0b] text-white grid md:grid-cols-[260px_1fr]" data-testid="admin-layout">
            <aside className="border-b md:border-b-0 md:border-r border-white/10 p-6 md:min-h-screen md:sticky md:top-0">
                <Link to="/" className="inline-block mb-10">
                    <img src={LOGO_WHITE} alt="N&M" className="h-8" />
                </Link>
                <div className="kicker text-white/40 mb-3">CMS</div>
                <nav className="flex md:flex-col gap-1 overflow-x-auto">
                    {NAV.map((n) => (
                        <NavLink
                            key={n.to}
                            to={n.to}
                            end={n.end}
                            data-testid={n.testId}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-4 py-3 text-sm border-l-2 transition-colors whitespace-nowrap ${
                                    isActive
                                        ? "border-[color:var(--brand-blue)] bg-white/5 text-white"
                                        : "border-transparent text-white/70 hover:text-white hover:bg-white/5"
                                }`
                            }
                        >
                            <n.icon size={16} />
                            {n.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="mt-10 pt-6 border-t border-white/10 text-xs text-white/50">
                    <div className="mb-2">{user.email}</div>
                    <button
                        onClick={logout}
                        className="inline-flex items-center gap-2 hover:text-white"
                        data-testid="admin-logout"
                    >
                        <LogOut size={14} /> Logout
                    </button>
                </div>
            </aside>
            <main className="p-6 md:p-10">
                <Outlet />
            </main>
        </div>
    );
}
